
export async function instantiate(imports={}, runInitializer=true) {
    const cachedJsObjects = new WeakMap();
    // ref must be non-null
    function getCachedJsObject(ref, ifNotCached) {
        if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
        const cached = cachedJsObjects.get(ref);
        if (cached !== void 0) return cached;
        cachedJsObjects.set(ref, ifNotCached);
        return ifNotCached;
    }

    const _ref_Li9za2lrby5tanM_ = imports['./skiko.mjs'];
    const _ref_QGpzLWpvZGEvY29yZQ_ = imports['@js-joda/core'];
    
    const js_code = {
        'kotlin.captureStackTrace' : () => new Error().stack,
        'kotlin.wasm.internal.stringLength' : (x) => x.length,
        'kotlin.wasm.internal.jsExportStringToWasm' : (src, srcOffset, srcLength, dstAddr) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, dstAddr, srcLength);
            let arrayIndex = 0;
            let srcIndex = srcOffset;
            while (arrayIndex < srcLength) {
                mem16.set([src.charCodeAt(srcIndex)], arrayIndex);
                srcIndex++;
                arrayIndex++;
            }     
             },
        'kotlin.wasm.internal.importStringFromWasm' : (address, length, prefix) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, address, length);
            const str = String.fromCharCode.apply(null, mem16);
            return (prefix == null) ? str : prefix + str;
             },
        'kotlin.wasm.internal.externrefToBoolean' : (ref) => Boolean(ref),
        'kotlin.wasm.internal.getJsEmptyString' : () => '',
        'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
        'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
        'kotlin.wasm.internal.externrefHashCode' : 
        (() => {
        const dataView = new DataView(new ArrayBuffer(8));
        function numberHashCode(obj) {
            if ((obj | 0) === obj) {
                return obj | 0;
            } else {
                dataView.setFloat64(0, obj, true);
                return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
            }
        }
        
        const hashCodes = new WeakMap();
        function getObjectHashCode(obj) {
            const res = hashCodes.get(obj);
            if (res === undefined) {
                const POW_2_32 = 4294967296;
                const hash = (Math.random() * POW_2_32) | 0;
                hashCodes.set(obj, hash);
                return hash;
            }
            return res;
        }
        
        function getStringHashCode(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code  = str.charCodeAt(i);
                hash  = (hash * 31 + code) | 0;
            }
            return hash;
        }
        
        return (obj) => {
            if (obj == null) {
                return 0;
            }
            switch (typeof obj) {
                case "object":
                case "function":
                    return getObjectHashCode(obj);
                case "number":
                    return numberHashCode(obj);
                case "boolean":
                    return obj ? 1231 : 1237;
                default:
                    return getStringHashCode(String(obj)); 
            }
        }
        })(),
        'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
        'kotlin.wasm.internal.getJsTrue' : () => true,
        'kotlin.wasm.internal.getJsFalse' : () => false,
        'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
        'kotlin.js.jsCatch' : (f) => { 
            let result = null;
            try { 
                f();
            } catch (e) {
               result = e;
            }
            return result;
             },
        'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
        'kotlin.js.jsThrow' : (e) => { throw e; },
        'kotlin.io.printError' : (error) => console.error(error),
        'kotlin.io.printlnImpl' : (message) => console.log(message),
        'kotlin.js.jsArrayGet' : (array, index) => array[index],
        'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
        'kotlin.js.JsArray_$external_fun' : () => new Array(),
        'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
        'kotlin.js.JsArray_$external_class_instanceof' : (x) => x instanceof Array,
        'kotlin.js.stackPlaceHolder_js_code' : () => (''),
        'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
        'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
        'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
        'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
        'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
        'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
        'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
        'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
        'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
        'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
        'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
        'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
        'kotlin.time.dateNow' : () => Date.now(),
        'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
        'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
        'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
        'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
        'kotlinx.coroutines.console_$external_prop_getter' : () => console,
        'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
        'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
        'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
        'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
            const handler = (event) => {
                if (event.source == window && event.data == 'dispatchCoroutine') {
                    event.stopPropagation();
                    process();
                }
            }
            window.addEventListener('message', handler, true);
        },
        'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
        'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
        'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
        'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
        'kotlinx.datetime.internal.JSJoda.atStartOfDay_$external_fun' : (_this, p0) => _this.atStartOfDay(p0),
        'kotlinx.datetime.internal.JSJoda.compareTo_$external_fun' : (_this, p0) => _this.compareTo(p0),
        'kotlinx.datetime.internal.JSJoda.dayOfMonth_$external_fun' : (_this, ) => _this.dayOfMonth(),
        'kotlinx.datetime.internal.JSJoda.dayOfWeek_$external_fun' : (_this, ) => _this.dayOfWeek(),
        'kotlinx.datetime.internal.JSJoda.dayOfYear_$external_fun' : (_this, ) => _this.dayOfYear(),
        'kotlinx.datetime.internal.JSJoda.equals_$external_fun' : (_this, p0) => _this.equals(p0),
        'kotlinx.datetime.internal.JSJoda.hashCode_$external_fun' : (_this, ) => _this.hashCode(),
        'kotlinx.datetime.internal.JSJoda.month_$external_fun' : (_this, ) => _this.month(),
        'kotlinx.datetime.internal.JSJoda.monthValue_$external_fun' : (_this, ) => _this.monthValue(),
        'kotlinx.datetime.internal.JSJoda.plusDays_$external_fun' : (_this, p0) => _this.plusDays(p0),
        'kotlinx.datetime.internal.JSJoda.plusMonths_$external_fun' : (_this, p0) => _this.plusMonths(p0),
        'kotlinx.datetime.internal.JSJoda.toEpochDay_$external_fun' : (_this, ) => _this.toEpochDay(),
        'kotlinx.datetime.internal.JSJoda.toString_$external_fun' : (_this, ) => _this.toString(),
        'kotlinx.datetime.internal.JSJoda.until_$external_fun' : (_this, p0, p1) => _this.until(p0, p1),
        'kotlinx.datetime.internal.JSJoda.year_$external_fun' : (_this, ) => _this.year(),
        'kotlinx.datetime.internal.JSJoda.MIN_$external_prop_getter' : (_this) => _this.MIN,
        'kotlinx.datetime.internal.JSJoda.MAX_$external_prop_getter' : (_this) => _this.MAX,
        'kotlinx.datetime.internal.JSJoda.of_$external_fun' : (_this, p0, p1, p2) => _this.of(p0, p1, p2),
        'kotlinx.datetime.internal.JSJoda.ofEpochDay_$external_fun' : (_this, p0) => _this.ofEpochDay(p0),
        'kotlinx.datetime.internal.JSJoda.parse_$external_fun' : (_this, p0) => _this.parse(p0),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.LocalDate,
        'kotlinx.datetime.internal.JSJoda.LocalDate_$external_class_instanceof' : (x) => x instanceof _ref_QGpzLWpvZGEvY29yZQ_.LocalDate,
        'kotlinx.datetime.internal.JSJoda.value_$external_fun' : (_this, ) => _this.value(),
        'kotlinx.datetime.internal.JSJoda.value_$external_fun_1' : (_this, ) => _this.value(),
        'kotlinx.datetime.internal.JSJoda.atZone_$external_fun' : (_this, p0) => _this.atZone(p0),
        'kotlinx.datetime.internal.JSJoda.compareTo_$external_fun_1' : (_this, p0) => _this.compareTo(p0),
        'kotlinx.datetime.internal.JSJoda.dayOfMonth_$external_fun_1' : (_this, ) => _this.dayOfMonth(),
        'kotlinx.datetime.internal.JSJoda.equals_$external_fun_1' : (_this, p0) => _this.equals(p0),
        'kotlinx.datetime.internal.JSJoda.hashCode_$external_fun_1' : (_this, ) => _this.hashCode(),
        'kotlinx.datetime.internal.JSJoda.hour_$external_fun' : (_this, ) => _this.hour(),
        'kotlinx.datetime.internal.JSJoda.minute_$external_fun' : (_this, ) => _this.minute(),
        'kotlinx.datetime.internal.JSJoda.month_$external_fun_1' : (_this, ) => _this.month(),
        'kotlinx.datetime.internal.JSJoda.monthValue_$external_fun_1' : (_this, ) => _this.monthValue(),
        'kotlinx.datetime.internal.JSJoda.second_$external_fun' : (_this, ) => _this.second(),
        'kotlinx.datetime.internal.JSJoda.toLocalDate_$external_fun' : (_this, ) => _this.toLocalDate(),
        'kotlinx.datetime.internal.JSJoda.toLocalTime_$external_fun' : (_this, ) => _this.toLocalTime(),
        'kotlinx.datetime.internal.JSJoda.toString_$external_fun_1' : (_this, ) => _this.toString(),
        'kotlinx.datetime.internal.JSJoda.year_$external_fun_1' : (_this, ) => _this.year(),
        'kotlinx.datetime.internal.JSJoda.MIN_$external_prop_getter_1' : (_this) => _this.MIN,
        'kotlinx.datetime.internal.JSJoda.MAX_$external_prop_getter_1' : (_this) => _this.MAX,
        'kotlinx.datetime.internal.JSJoda.of_$external_fun_1' : (_this, p0, p1) => _this.of(p0, p1),
        'kotlinx.datetime.internal.JSJoda.of_$external_fun_2' : (_this, p0, p1, p2, p3, p4, p5, p6) => _this.of(p0, p1, p2, p3, p4, p5, p6),
        'kotlinx.datetime.internal.JSJoda.ofInstant_$external_fun' : (_this, p0, p1) => _this.ofInstant(p0, p1),
        'kotlinx.datetime.internal.JSJoda.parse_$external_fun_1' : (_this, p0) => _this.parse(p0),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_1' : () => _ref_QGpzLWpvZGEvY29yZQ_.LocalDateTime,
        'kotlinx.datetime.internal.JSJoda.LocalDateTime_$external_class_instanceof' : (x) => x instanceof _ref_QGpzLWpvZGEvY29yZQ_.LocalDateTime,
        'kotlinx.datetime.internal.JSJoda.compareTo_$external_fun_2' : (_this, p0) => _this.compareTo(p0),
        'kotlinx.datetime.internal.JSJoda.equals_$external_fun_2' : (_this, p0) => _this.equals(p0),
        'kotlinx.datetime.internal.JSJoda.hashCode_$external_fun_2' : (_this, ) => _this.hashCode(),
        'kotlinx.datetime.internal.JSJoda.hour_$external_fun_1' : (_this, ) => _this.hour(),
        'kotlinx.datetime.internal.JSJoda.minute_$external_fun_1' : (_this, ) => _this.minute(),
        'kotlinx.datetime.internal.JSJoda.nano_$external_fun' : (_this, ) => _this.nano(),
        'kotlinx.datetime.internal.JSJoda.second_$external_fun_1' : (_this, ) => _this.second(),
        'kotlinx.datetime.internal.JSJoda.toSecondOfDay_$external_fun' : (_this, ) => _this.toSecondOfDay(),
        'kotlinx.datetime.internal.JSJoda.toString_$external_fun_2' : (_this, ) => _this.toString(),
        'kotlinx.datetime.internal.JSJoda.MIN_$external_prop_getter_2' : (_this) => _this.MIN,
        'kotlinx.datetime.internal.JSJoda.MAX_$external_prop_getter_2' : (_this) => _this.MAX,
        'kotlinx.datetime.internal.JSJoda.of_$external_fun_3' : (_this, p0, p1, p2, p3) => _this.of(p0, p1, p2, p3),
        'kotlinx.datetime.internal.JSJoda.parse_$external_fun_2' : (_this, p0) => _this.parse(p0),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_2' : () => _ref_QGpzLWpvZGEvY29yZQ_.LocalTime,
        'kotlinx.datetime.internal.JSJoda.LocalTime_$external_class_instanceof' : (x) => x instanceof _ref_QGpzLWpvZGEvY29yZQ_.LocalTime,
        'kotlinx.datetime.internal.JSJoda.parse_$external_fun_3' : (_this, p0) => _this.parse(p0),
        'kotlinx.datetime.internal.JSJoda.DateTimeFormatterBuilder_$external_fun' : () => new _ref_QGpzLWpvZGEvY29yZQ_.DateTimeFormatterBuilder(),
        'kotlinx.datetime.internal.JSJoda.appendOffset_$external_fun' : (_this, p0, p1) => _this.appendOffset(p0, p1),
        'kotlinx.datetime.internal.JSJoda.appendOffsetId_$external_fun' : (_this, ) => _this.appendOffsetId(),
        'kotlinx.datetime.internal.JSJoda.parseCaseInsensitive_$external_fun' : (_this, ) => _this.parseCaseInsensitive(),
        'kotlinx.datetime.internal.JSJoda.toFormatter_$external_fun' : (_this, p0) => _this.toFormatter(p0),
        'kotlinx.datetime.internal.JSJoda.STRICT_$external_prop_getter' : (_this) => _this.STRICT,
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_3' : () => _ref_QGpzLWpvZGEvY29yZQ_.ResolverStyle,
        'kotlinx.datetime.internal.JSJoda.equals_$external_fun_3' : (_this, p0) => _this.equals(p0),
        'kotlinx.datetime.internal.JSJoda.hashCode_$external_fun_3' : (_this, ) => _this.hashCode(),
        'kotlinx.datetime.internal.JSJoda.toString_$external_fun_3' : (_this, ) => _this.toString(),
        'kotlinx.datetime.internal.JSJoda.totalSeconds_$external_fun' : (_this, ) => _this.totalSeconds(),
        'kotlinx.datetime.internal.JSJoda.UTC_$external_prop_getter' : (_this) => _this.UTC,
        'kotlinx.datetime.internal.JSJoda.ofHoursMinutesSeconds_$external_fun' : (_this, p0, p1, p2) => _this.ofHoursMinutesSeconds(p0, p1, p2),
        'kotlinx.datetime.internal.JSJoda.ofTotalSeconds_$external_fun' : (_this, p0) => _this.ofTotalSeconds(p0),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_4' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneOffset,
        'kotlinx.datetime.internal.JSJoda.ZoneOffset_$external_class_instanceof' : (x) => x instanceof _ref_QGpzLWpvZGEvY29yZQ_.ZoneOffset,
        'kotlinx.datetime.internal.JSJoda.get_$external_fun' : (_this, p0) => _this.get(p0),
        'kotlinx.datetime.internal.JSJoda.OFFSET_SECONDS_$external_prop_getter' : (_this) => _this.OFFSET_SECONDS,
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_5' : () => _ref_QGpzLWpvZGEvY29yZQ_.ChronoField,
        'kotlinx.datetime.internal.JSJoda.equals_$external_fun_4' : (_this, p0) => _this.equals(p0),
        'kotlinx.datetime.internal.JSJoda.hashCode_$external_fun_4' : (_this, ) => _this.hashCode(),
        'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
        'kotlinx.datetime.internal.JSJoda.normalized_$external_fun' : (_this, ) => _this.normalized(),
        'kotlinx.datetime.internal.JSJoda.rules_$external_fun' : (_this, ) => _this.rules(),
        'kotlinx.datetime.internal.JSJoda.toString_$external_fun_4' : (_this, ) => _this.toString(),
        'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
        'kotlinx.datetime.internal.JSJoda.of_$external_fun_4' : (_this, p0) => _this.of(p0),
        'kotlinx.datetime.internal.JSJoda.getAvailableZoneIds_$external_fun' : (_this, ) => _this.getAvailableZoneIds(),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_6' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
        'kotlinx.datetime.internal.JSJoda.ZoneId_$external_class_instanceof' : (x) => x instanceof _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
        'kotlinx.datetime.internal.JSJoda.instant_$external_fun' : (_this, ) => _this.instant(),
        'kotlinx.datetime.internal.JSJoda.systemUTC_$external_fun' : (_this, ) => _this.systemUTC(),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_7' : () => _ref_QGpzLWpvZGEvY29yZQ_.Clock,
        'kotlinx.datetime.internal.JSJoda.compareTo_$external_fun_3' : (_this, p0) => _this.compareTo(p0),
        'kotlinx.datetime.internal.JSJoda.epochSecond_$external_fun' : (_this, ) => _this.epochSecond(),
        'kotlinx.datetime.internal.JSJoda.equals_$external_fun_5' : (_this, p0) => _this.equals(p0),
        'kotlinx.datetime.internal.JSJoda.hashCode_$external_fun_5' : (_this, ) => _this.hashCode(),
        'kotlinx.datetime.internal.JSJoda.nano_$external_fun_1' : (_this, ) => _this.nano(),
        'kotlinx.datetime.internal.JSJoda.toString_$external_fun_5' : (_this, ) => _this.toString(),
        'kotlinx.datetime.internal.JSJoda.MIN_$external_prop_getter_3' : (_this) => _this.MIN,
        'kotlinx.datetime.internal.JSJoda.MAX_$external_prop_getter_3' : (_this) => _this.MAX,
        'kotlinx.datetime.internal.JSJoda.ofEpochSecond_$external_fun' : (_this, p0, p1) => _this.ofEpochSecond(p0, p1),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_8' : () => _ref_QGpzLWpvZGEvY29yZQ_.Instant,
        'kotlinx.datetime.internal.JSJoda.Instant_$external_class_instanceof' : (x) => x instanceof _ref_QGpzLWpvZGEvY29yZQ_.Instant,
        'kotlinx.datetime.internal.JSJoda.DAYS_$external_prop_getter' : (_this) => _this.DAYS,
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_9' : () => _ref_QGpzLWpvZGEvY29yZQ_.ChronoUnit,
        'kotlinx.datetime.internal.JSJoda.isFixedOffset_$external_fun' : (_this, ) => _this.isFixedOffset(),
        'kotlinx.datetime.internal.JSJoda.offsetOfInstant_$external_fun' : (_this, p0) => _this.offsetOfInstant(p0),
        'kotlinx.datetime.internal.JSJoda.toInstant_$external_fun' : (_this, ) => _this.toInstant(),
        'kotlinx.datetime.internal.JSJoda.nano_$external_fun_2' : (_this, ) => _this.nano(),
        'kotlinx.datetime.internal.JSJoda.seconds_$external_fun' : (_this, ) => _this.seconds(),
        'kotlinx.datetime.internal.JSJoda.between_$external_fun' : (_this, p0, p1) => _this.between(p0, p1),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance_10' : () => _ref_QGpzLWpvZGEvY29yZQ_.Duration,
        'kotlinx.datetime.withCaughtJsException' : (body) => {
            try {
                body();
                return null;
            } catch(e) {
                return e;
            }
        },
        'kotlinx.datetime.getExceptionMessage' : (jsException) => jsException.message,
        'kotlinx.datetime.checkExceptionName' : (exception, name) => exception.name === name,
        'com.aizsquare.secretsalah.data.hijri.jsFetchFirestoreDoc' : (projectId, path, onSuccess, onError) => {
          const ok = (v) => setTimeout(() => onSuccess(v), 0);
          try {
            fetch('https://firestore.googleapis.com/v1/projects/' + projectId +
                  '/databases/(default)/documents/' + path, { mode: 'cors', cache: 'no-store' })
            .then(function(r) {
              if (!r.ok) { ok(''); return; }
              return r.text().then(ok).catch(function() { ok(''); });
            })
            .catch(function() { ok(''); });
          } catch(e) { ok(''); }
        },
        'com.aizsquare.secretsalah.data.hijri.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
        'com.aizsquare.secretsalah.data.storage.jsGet' : (key) => localStorage.getItem(key),
        'com.aizsquare.secretsalah.data.storage.jsSet' : (key, value) => localStorage.setItem(key, value),
        'com.aizsquare.secretsalah.data.storage.jsRemove' : (key) => localStorage.removeItem(key),
        'com.aizsquare.secretsalah.data.storage.jsGetAllKeys' : () => {
          const keys = [];
          for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i);
            if (k !== null) keys.push(k);
          }
          return keys.join(' ');
        },
        'com.aizsquare.secretsalah.data.sync.jsEncrypt' : (passphrase, plaintext, onSuccess, onError) => {
          const enc = new TextEncoder();
          const salt = crypto.getRandomValues(new Uint8Array(16));
          const iv   = crypto.getRandomValues(new Uint8Array(12));
          crypto.subtle.importKey('raw', enc.encode(passphrase), 'PBKDF2', false, ['deriveKey'])
            .then(k => crypto.subtle.deriveKey(
              { name: 'PBKDF2', salt, iterations: 100000, hash: 'SHA-256' },
              k, { name: 'AES-GCM', length: 256 }, false, ['encrypt']
            ))
            .then(aes => crypto.subtle.encrypt({ name: 'AES-GCM', iv }, aes, enc.encode(plaintext)))
            .then(ct => {
              const out = new Uint8Array(16 + 12 + ct.byteLength);
              out.set(salt, 0); out.set(iv, 16); out.set(new Uint8Array(ct), 28);
              let b = ''; out.forEach(x => b += String.fromCharCode(x));
              onSuccess(btoa(b));
            })
            .catch(e => onError(String(e)));
        },
        'com.aizsquare.secretsalah.data.sync.jsDecrypt' : (passphrase, b64, onSuccess, onError) => {
          try {
            const raw  = Uint8Array.from(atob(b64), c => c.charCodeAt(0));
            const salt = raw.slice(0, 16);
            const iv   = raw.slice(16, 28);
            const ct   = raw.slice(28);
            const enc  = new TextEncoder();
            crypto.subtle.importKey('raw', enc.encode(passphrase), 'PBKDF2', false, ['deriveKey'])
              .then(k => crypto.subtle.deriveKey(
                { name: 'PBKDF2', salt, iterations: 100000, hash: 'SHA-256' },
                k, { name: 'AES-GCM', length: 256 }, false, ['decrypt']
              ))
              .then(aes => crypto.subtle.decrypt({ name: 'AES-GCM', iv }, aes, ct))
              .then(pt  => onSuccess(new TextDecoder().decode(pt)))
              .catch(e  => onError(String(e)));
          } catch (e) { onError(String(e)); }
        },
        'com.aizsquare.secretsalah.data.sync.jsTriggerDownload' : (content, filename) => {
          const blob = new Blob([content], { type: 'text/plain' });
          const url  = URL.createObjectURL(blob);
          const a    = document.createElement('a');
          a.href = url; a.download = filename;
          document.body.appendChild(a); a.click();
          document.body.removeChild(a); URL.revokeObjectURL(url);
        },
        'com.aizsquare.secretsalah.data.sync.jsPickFile' : (onSuccess, onError) => {
          const input = document.createElement('input');
          input.type = 'file'; input.accept = '.enc,.txt';
          input.onchange = () => {
            const file = input.files && input.files[0];
            if (!file) { onError('No file selected'); return; }
            const reader = new FileReader();
            reader.onload  = e => onSuccess(e.target.result);
            reader.onerror = () => onError('Failed to read file');
            reader.readAsText(file);
          };
          input.click();
        },
        'com.aizsquare.secretsalah.data.sync.jsRequestOtp' : (url, phone, onSuccess, onError) => {
          const ok  = () => setTimeout(() => onSuccess(), 0);
          const err = (msg) => setTimeout(() => onError(String(msg)), 0);
          try {
            fetch(url, {
              method: 'POST',
              mode: 'cors',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ phone: phone })
            })
            .then(function(r) {
              return r.json().then(function(d) {
                if (r.ok) { ok(); return; }
                err((d.error) || 'Request failed (' + r.status + ')');
              }).catch(function() { err('Server error ' + r.status); });
            })
            .catch(function(e) { err(e); });
          } catch(e) { err(e); }
        },
        'com.aizsquare.secretsalah.data.sync.jsVerifyAndSignIn' : (verifyUrl, finalizeUrl, apiKey, phone, code, onSuccess, onError) => {
          const ok  = (v) => setTimeout(() => onSuccess(v), 0);
          const err = (msg) => setTimeout(() => onError(String(msg)), 0);
          try {
            // Step 1 — verify OTP, receive HMAC proof
            fetch(verifyUrl, {
              method: 'POST',
              mode: 'cors',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ phone: phone, code: code })
            })
            .then(function(r) {
              return r.json().then(function(d) {
                if (!r.ok) { err(d.error || 'Verification failed (' + r.status + ')'); return; }
                const proof = d.proof;
        
                // Step 2 — exchange proof for a Firebase custom token (minted by secret-salah)
                return fetch(finalizeUrl, {
                  method: 'POST',
                  mode: 'cors',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ proof: proof })
                })
                .then(function(r2) {
                  return r2.json().then(function(d2) {
                    if (!r2.ok) { err(d2.error || 'Auth finalization failed (' + r2.status + ')'); return; }
                    const customToken = d2.token;
        
                    // Step 3 — exchange custom token for Firebase idToken via Identity Toolkit
                    return fetch(
                      'https://identitytoolkit.googleapis.com/v1/accounts:signInWithCustomToken?key=' + apiKey,
                      {
                        method: 'POST',
                        mode: 'cors',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ token: customToken, returnSecureToken: true })
                      }
                    )
                    .then(function(r3) {
                      return r3.json().then(function(d3) {
                        if (!r3.ok) { err((d3.error && d3.error.message) || 'Sign-in failed (' + r3.status + ')'); return; }
                        // d3.localId is not always present in this response — decode the
                        // uid straight from the idToken JWT's payload instead (user_id/sub
                        // claim), which is always there and is what Firestore's security
                        // rules actually check against (request.auth.uid).
                        var uid = d3.localId;
                        if (!uid) {
                          try {
                            var payload = JSON.parse(atob(d3.idToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
                            uid = payload.user_id || payload.sub;
                          } catch (e) {}
                        }
                        if (!uid) { err('Sign-in failed: no uid in response'); return; }
                        ok([d3.idToken, d3.refreshToken, uid, phone].join('|'));
                      }).catch(function() { err('Server error ' + r3.status); });
                    });
                  }).catch(function() { err('Server error ' + r2.status); });
                });
              }).catch(function() { err('Server error ' + r.status); });
            })
            .catch(function(e) { err(e); });
          } catch(e) { err(e); }
        },
        'com.aizsquare.secretsalah.data.sync.jsDeleteAccount' : (url, idToken, onSuccess, onError) => {
          const ok  = () => setTimeout(() => onSuccess(), 0);
          const err = (status, msg) => setTimeout(() => onError(status, String(msg)), 0);
          try {
            fetch(url, {
              method: 'POST',
              mode: 'cors',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ idToken: idToken })
            })
            .then(function(r) {
              return r.json().then(function(d) {
                if (r.ok) { ok(); return; }
                err(r.status, (d.error) || 'Request failed (' + r.status + ')');
              }).catch(function() { err(r.status, 'Server error ' + r.status); });
            })
            .catch(function(e) { err(0, e); });
          } catch(e) { err(0, e); }
        },
        'com.aizsquare.secretsalah.data.sync.__convertKotlinClosureToJsClosure_((Int,String)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Int,String)->Unit)'](f, p0, p1)),
        'com.aizsquare.secretsalah.data.sync.jsFirebaseRefreshToken' : (apiKey, refreshToken, onSuccess, onError) => {
          const ok  = (v) => setTimeout(() => onSuccess(v), 0);
          const err = (msg) => setTimeout(() => onError(String(msg)), 0);
          try {
            fetch('https://securetoken.googleapis.com/v1/token?key=' + apiKey, {
              method: 'POST',
              mode: 'cors',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ grant_type: 'refresh_token', refresh_token: refreshToken })
            })
            .then(function(r) {
              return r.json().then(function(d) {
                if (!r.ok) { err((d.error && d.error.message) || 'Refresh failed (' + r.status + ')'); return; }
                ok(d.id_token + '|' + d.refresh_token);
              }).catch(function() { err('Server error ' + r.status); });
            })
            .catch(function(e) { err(e); });
          } catch(e) { err(e); }
        },
        'com.aizsquare.secretsalah.data.sync.jsDateNow' : () => String(Date.now()),
        'com.aizsquare.secretsalah.data.sync.jsSaveLastSyncMetaWrite' : (v) => { try { localStorage.setItem('ss_lsmw', v); } catch(e) {} },
        'com.aizsquare.secretsalah.data.sync.jsFirestoreUpdateUserData' : (projectId, idToken, userId, jsonObject, onSuccess, onError) => {
          const ok  = () => setTimeout(() => onSuccess(), 0);
          const err = (msg) => setTimeout(() => onError(String(msg)), 0);
        
          function toFields(obj) {
            const f = {};
            Object.entries(obj).forEach(function(e) {
              const k = e[0], v = e[1];
              if (typeof v === 'string')        f[k] = {stringValue: v};
              else if (typeof v === 'boolean')  f[k] = {booleanValue: v};
              else if (typeof v === 'number') {
                if (Number.isInteger(v))        f[k] = {integerValue: String(v)};
                else                            f[k] = {doubleValue: v};
              }
              else if (v === null || v === undefined) f[k] = {nullValue: null};
            });
            return f;
          }
        
          try {
            const s = JSON.parse(jsonObject);
            // IMPORTANT: build an updateMask from the present keys. Without a mask the
            // Firestore REST PATCH replaces the ENTIRE document, which would wipe out
            // settings + backlog when we only mean to touch last_changed.
            const mask = Object.keys(s)
              .map(function(k) { return 'updateMask.fieldPaths=' + encodeURIComponent(k); })
              .join('&');
            fetch('https://firestore.googleapis.com/v1/projects/' + projectId +
                  '/databases/(default)/documents/user_data/' + userId + '?' + mask, {
              method: 'PATCH',
              mode: 'cors',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + idToken
              },
              body: JSON.stringify({fields: toFields(s)})
            })
            .then(function(r) {
              r.ok ? ok() : r.text().then(function(t) { err(t || 'UserData upsert failed'); });
            })
            .catch(function(e) { err(e); });
          } catch(e) { err(e); }
        },
        'com.aizsquare.secretsalah.data.sync.jsLoadLastSyncMetaWrite' : () => { try { return localStorage.getItem('ss_lsmw') || ''; } catch(e) { return ''; } },
        'com.aizsquare.secretsalah.data.sync.jsLoadLastPullAttemptAt' : () => { try { return localStorage.getItem('ss_lpaa') || ''; } catch(e) { return ''; } },
        'com.aizsquare.secretsalah.data.sync.jsSaveLastPullAttemptAt' : (v) => { try { localStorage.setItem('ss_lpaa', v); } catch(e) {} },
        'com.aizsquare.secretsalah.data.sync.jsLoadLastPullAt' : () => { try { return localStorage.getItem('ss_lpa') || ''; } catch(e) { return ''; } },
        'com.aizsquare.secretsalah.data.sync.jsFirestoreGetUserData' : (projectId, idToken, userId, onSuccess, onError) => {
          const ok  = (v) => setTimeout(() => onSuccess(v), 0);
          const err = (msg) => setTimeout(() => onError(String(msg)), 0);
        
          function fromFields(fields) {
            const obj = {};
            Object.entries(fields).forEach(function(e) {
              const k = e[0], v = e[1];
              if      ('stringValue'  in v) obj[k] = v.stringValue;
              else if ('booleanValue' in v) obj[k] = v.booleanValue;
              else if ('integerValue' in v) obj[k] = parseInt(v.integerValue, 10);
              else if ('doubleValue'  in v) obj[k] = v.doubleValue;
              else                          obj[k] = null;
            });
            return obj;
          }
        
          try {
            fetch('https://firestore.googleapis.com/v1/projects/' + projectId +
                  '/databases/(default)/documents/user_data/' + userId, {
              mode: 'cors',
              cache: 'no-store',
              headers: { 'Authorization': 'Bearer ' + idToken }
            })
            .then(function(r) {
              if (r.status === 404) { ok('{}'); return; }
              return r.json().then(function(d) {
                if (!r.ok) { ok('{}'); return; }
                ok(JSON.stringify(fromFields(d.fields)));
              }).catch(function() { ok('{}'); });
            })
            .catch(function() { ok('{}'); });
          } catch(e) { ok('{}'); }
        },
        'com.aizsquare.secretsalah.data.sync.jsFirestoreGetDocFields' : (projectId, idToken, path, onSuccess, onError) => {
          const ok = (v) => setTimeout(() => onSuccess(v), 0);
          try {
            fetch('https://firestore.googleapis.com/v1/projects/' + projectId +
                  '/databases/(default)/documents/' + path, {
              mode: 'cors',
              cache: 'no-store',
              headers: { 'Authorization': 'Bearer ' + idToken }
            })
            .then(function(r) {
              if (r.status === 404) { ok('{}'); return; }
              return r.json().then(function(d) {
                if (!r.ok) { ok('{}'); return; }
                ok(JSON.stringify(d.fields || {}));
              }).catch(function() { ok('{}'); });
            })
            .catch(function() { ok('{}'); });
          } catch(e) { ok('{}'); }
        },
        'com.aizsquare.secretsalah.data.sync.jsLoadLastPrayerPushConfirmedAt' : () => { try { return localStorage.getItem('ss_lppca') || ''; } catch(e) { return ''; } },
        'com.aizsquare.secretsalah.data.sync.jsSaveLastPullAt' : (v) => { try { localStorage.setItem('ss_lpa', v); } catch(e) {} },
        'com.aizsquare.secretsalah.data.sync.jsFirestoreGetYearlyLog' : (projectId, idToken, userId, year, onSuccess, onError) => {
          const ok = (v) => setTimeout(() => onSuccess(v), 0);
          try {
            fetch('https://firestore.googleapis.com/v1/projects/' + projectId +
                  '/databases/(default)/documents/users/' + userId + '/yearlyLogs/' + year, {
              mode: 'cors',
              cache: 'no-store',
              headers: { 'Authorization': 'Bearer ' + idToken }
            })
            .then(function(r) {
              if (r.status === 404) { ok(JSON.stringify({status: 404})); return; }
              if (!r.ok) { ok(JSON.stringify({status: r.status})); return; }
              return r.json().then(function(d) {
                ok(JSON.stringify({status: 200, fields: d.fields || {}}));
              }).catch(function() { ok(JSON.stringify({status: 0})); });
            })
            .catch(function() { ok(JSON.stringify({status: 0})); });
          } catch(e) { ok(JSON.stringify({status: 0})); }
        },
        'com.aizsquare.secretsalah.data.sync.jsFirestorePatchYearlyLogMonths' : (projectId, idToken, userId, year, monthsJson, nowMs, onSuccess, onError) => {
          const ok  = () => setTimeout(() => onSuccess(), 0);
          const err = (msg) => setTimeout(() => onError(String(msg)), 0);
          try {
            const months = JSON.parse(monthsJson);
            const fields = {
              year: {integerValue: String(year)},
              last_updated: {integerValue: String(nowMs)}
            };
            Object.keys(months).forEach(function(k) {
              fields[k] = {arrayValue: {values: months[k].map(function(v) {
                return {integerValue: String(v)};
              })}};
            });
            const mask = Object.keys(fields)
              .map(function(k) { return 'updateMask.fieldPaths=' + encodeURIComponent(k); })
              .join('&');
            fetch('https://firestore.googleapis.com/v1/projects/' + projectId +
                  '/databases/(default)/documents/users/' + userId + '/yearlyLogs/' + year + '?' + mask, {
              method: 'PATCH',
              mode: 'cors',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + idToken
              },
              body: JSON.stringify({fields: fields})
            })
            .then(function(r) {
              r.ok ? ok() : r.text().then(function(t) { err(t || 'yearlyLogs patch failed'); });
            })
            .catch(function(e) { err(e); });
          } catch(e) { err(e); }
        },
        'com.aizsquare.secretsalah.data.sync.jsFirestoreUpdateQadaSummary' : (projectId, idToken, userId, jsonObject, onSuccess, onError) => {
          const ok  = () => setTimeout(() => onSuccess(), 0);
          const err = (msg) => setTimeout(() => onError(String(msg)), 0);
        
          function toFields(obj) {
            const f = {};
            Object.entries(obj).forEach(function(e) {
              const k = e[0], v = e[1];
              if (typeof v === 'string')        f[k] = {stringValue: v};
              else if (typeof v === 'boolean')  f[k] = {booleanValue: v};
              else if (typeof v === 'number') {
                if (Number.isInteger(v))        f[k] = {integerValue: String(v)};
                else                            f[k] = {doubleValue: v};
              }
              else if (v === null || v === undefined) f[k] = {nullValue: null};
            });
            return f;
          }
        
          try {
            const s = JSON.parse(jsonObject);
            const mask = Object.keys(s)
              .map(function(k) { return 'updateMask.fieldPaths=' + encodeURIComponent(k); })
              .join('&');
            fetch('https://firestore.googleapis.com/v1/projects/' + projectId +
                  '/databases/(default)/documents/users/' + userId + '/qada/summary?' + mask, {
              method: 'PATCH',
              mode: 'cors',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + idToken
              },
              body: JSON.stringify({fields: toFields(s)})
            })
            .then(function(r) {
              r.ok ? ok() : r.text().then(function(t) { err(t || 'QadaSummary upsert failed'); });
            })
            .catch(function(e) { err(e); });
          } catch(e) { err(e); }
        },
        'com.aizsquare.secretsalah.data.sync.jsSaveLastPrayerPushConfirmedAt' : (v) => { try { localStorage.setItem('ss_lppca', v); } catch(e) {} },
        'com.aizsquare.secretsalah.data.sync.jsGetBrowserLocation' : (onSuccess, onError) => {
          if (!navigator.geolocation) { onError('Geolocation not supported'); return; }
          navigator.geolocation.getCurrentPosition(
            pos => onSuccess(pos.coords.latitude, pos.coords.longitude),
            err => onError(err.message || 'Location denied'),
            { enableHighAccuracy: false, timeout: 10000 }
          );
        },
        'com.aizsquare.secretsalah.data.sync.__convertKotlinClosureToJsClosure_((Double,Double)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Double,Double)->Unit)'](f, p0, p1)),
        'com.aizsquare.secretsalah.data.sync.jsSearchCity' : (query, onSuccess, onError) => {
          const url = 'https://nominatim.openstreetmap.org/search?q='
            + encodeURIComponent(query)
            + '&format=json&limit=6&addressdetails=1';
          fetch(url, { headers: { 'Accept-Language': 'en', 'User-Agent': 'SecretSalahApp/1.0' } })
            .then(r => r.json())
            .then(results => {
              const lines = results.map(r => {
                const addr = r.address || {};
                const name = addr.city || addr.town || addr.village || addr.county || r.name || '';
                const cc = (addr.country_code || '').toLowerCase();
                return [name, r.lat, r.lon, r.display_name, cc].join('|');
              });
              onSuccess(lines.join('\n'));
            })
            .catch(e => onError(String(e)));
        },
        'com.aizsquare.secretsalah.data.sync.jsReverseGeocode' : (lat, lon, onSuccess, onError) => {
          const url = 'https://nominatim.openstreetmap.org/reverse?lat=' + lat + '&lon=' + lon
            + '&format=json&zoom=10';
          fetch(url, { headers: { 'Accept-Language': 'en', 'User-Agent': 'SecretSalahApp/1.0' } })
            .then(r => r.json())
            .then(data => {
              const addr = data.address || {};
              const name = addr.city || addr.town || addr.village || addr.county || data.name || 'Unknown';
              const cc = (addr.country_code || '').toLowerCase();
              onSuccess(name + '|' + cc);
            })
            .catch(e => onError(String(e)));
        },
        'kotlinx.browser.window_$external_prop_getter' : () => window,
        'kotlinx.browser.document_$external_prop_getter' : () => document,
        'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
        'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
        'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
        'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
        'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
        'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
        'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
        'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
        'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
        'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
        'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
        'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
        'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
        'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
        'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
        'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
        'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
        'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
        'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
        'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
        'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
        'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
        'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
        'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
        'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
        'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
        'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
        'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
        'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => { return { passive, once, capture }; },
        'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
        'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
        'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
        'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
        'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
        'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
        'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
        'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
        'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
        'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
        'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
        'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
        'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
        'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
        'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
        'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
        'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
        'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
        'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
        'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
        'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
        'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
        'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
        'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
        'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
        'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
        'org.w3c.dom.right_$external_prop_getter' : (_this) => _this.right,
        'org.w3c.dom.bottom_$external_prop_getter' : (_this) => _this.bottom,
        'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
        'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
        'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
        'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
        'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
        'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
        'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
        'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
        'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
        'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
        'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
        'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
        'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
        'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
        'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
        'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
        'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
        'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
        'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
        'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
        'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_._releaseLocalCallbackScope(),
        'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
        'org.jetbrains.skiko.wasm.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
        'org.jetbrains.skiko.wasm.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
        'org.jetbrains.skiko.wasm.GL_$external_object_getInstance' : () => _ref_Li9za2lrby5tanM_.GL,
        'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
            return {
                alpha: 1,
                depth: 1,
                stencil: 8,
                antialias: 0,
                premultipliedAlpha: 1,
                preserveDrawingBuffer: 0,
                preferLowPowerToHighPerformance: 0,
                failIfMajorPerformanceCaveat: 0,
                enableExtensionsByDefault: 1,
                explicitSwapControl: 0,
                renderViaOffscreenBackBuffer: 0,
                majorVersion: 2,
            }
        }
        ,
        'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
        'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
        'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
        'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
        'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
        'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext,
        'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
        'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
        'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
        'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
        'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
        'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
        'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
        'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
        'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
        'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
        'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
        'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
        'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
        'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
        'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
        'androidx.compose.ui.platform.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
        'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
        'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
        'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
        'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
        'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.compose.material3.internal.getFirstDayOfWeek' : (locale) => { try { 
                   return new Intl.Locale(locale).weekInfo.firstDay; 
                } catch (error) { 
                   return -1; 
              }},
        'androidx.compose.material3.internal.emptyLocaleOptions' : () => new Object(),
        'androidx.compose.material3.internal.Date_$external_fun' : (p0) => new Date(p0),
        'androidx.compose.material3.internal.Date_$external_fun_1' : (p0, p1, p2) => new Date(p0, p1, p2),
        'androidx.compose.material3.internal.getDay_$external_fun' : (_this, ) => _this.getDay(),
        'androidx.compose.material3.internal.toLocaleDateString_$external_fun' : (_this, p0, p1, isDefault0) => _this.toLocaleDateString(p0, isDefault0 ? undefined : p1, ),
        'androidx.compose.material3.internal.now_$external_fun' : (_this, ) => _this.now(),
        'androidx.compose.material3.internal.Companion_$external_object_getInstance' : () => Date,
        'androidx.compose.material3.internal.weekday_$external_prop_setter' : (_this, v) => _this.weekday = v,
        'androidx.compose.material3.internal.year_$external_prop_setter' : (_this, v) => _this.year = v,
        'androidx.compose.material3.internal.month_$external_prop_setter' : (_this, v) => _this.month = v,
        'androidx.compose.material3.internal.day_$external_prop_setter' : (_this, v) => _this.day = v,
        'androidx.compose.material3.internal.hour_$external_prop_setter' : (_this, v) => _this.hour = v,
        'androidx.compose.material3.internal.minute_$external_prop_setter' : (_this, v) => _this.minute = v,
        'androidx.compose.material3.internal.second_$external_prop_setter' : (_this, v) => _this.second = v,
        'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
        'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
        'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
        'org.jetbrains.compose.resources.jsExportInt8ArrayToWasm' :  (src, size, dstAddr) => {
                const mem8 = new Int8Array(wasmExports.memory.buffer, dstAddr, size);
                mem8.set(src);
            }
        ,
        'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
                var text = req.responseText;
                var int8Arr = new Int8Array(text.length);
                for (var i = 0; i < text.length; i++) {
                    int8Arr[i] = text.charCodeAt(i) & 0xFF;
                }
                return int8Arr;
            },
        'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
        'com.aizsquare.secretsalah.platform.onVisibilityChange' : (callback) => {
          document.addEventListener('visibilitychange', function() {
            callback(document.visibilityState === 'hidden');
          });
        },
        'com.aizsquare.secretsalah.platform.__convertKotlinClosureToJsClosure_((Boolean)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Boolean)->Unit)'](f, p0)),
        'com.aizsquare.secretsalah.platform.jsClearCacheAndReload' : () => {
          navigator.serviceWorker.getRegistrations().then(regs => {
            Promise.all(regs.map(r => r.unregister())).then(() => {
              caches.keys().then(keys => {
                Promise.all(keys.map(k => caches.delete(k))).then(() => {
                  window.location.reload(true);
                });
              });
            });
          });
        },
        'com.aizsquare.secretsalah.platform.jsGetSafeAreaTop' : () => {
          try {
            var el = document.createElement('div');
            el.style.cssText = 'position:fixed;top:env(safe-area-inset-top,0px);height:0;width:0;visibility:hidden;pointer-events:none';
            document.documentElement.appendChild(el);
            var v = parseFloat(window.getComputedStyle(el).top) || 0;
            document.documentElement.removeChild(el);
            return v;
          } catch(e) { return 0; }
        },
        'com.aizsquare.secretsalah.platform.jsGetSafeAreaBottom' : () => {
          try {
            var el = document.createElement('div');
            el.style.cssText = 'position:fixed;bottom:env(safe-area-inset-bottom,0px);height:0;width:0;visibility:hidden;pointer-events:none';
            document.documentElement.appendChild(el);
            var v = parseFloat(window.getComputedStyle(el).bottom) || 0;
            document.documentElement.removeChild(el);
            return v;
          } catch(e) { return 0; }
        },
        'com.aizsquare.secretsalah.platform.vibrate' : (ms) => { if (typeof navigator !== 'undefined' && navigator.vibrate) { navigator.vibrate(ms); } },
        'com.aizsquare.secretsalah.platform.jsFetchTimezoneOffset' : (lat, lon, onSuccess, onError) => {
            fetch('https://timeapi.io/api/time/current/coordinate?latitude=' + lat + '&longitude=' + lon)
                .then(r => r.json())
                .then(data => {
                    if (!data.timeZone) { onError('no timeZone in response'); return; }
                    try {
                        // Use Intl to get actual UTC offset for the IANA timezone (DST-aware)
                        const d = new Date();
                        const utcMs = new Date(d.toLocaleString('en-US', {timeZone: 'UTC'})) - 0;
                        const tzMs  = new Date(d.toLocaleString('en-US', {timeZone: data.timeZone})) - 0;
                        const offsetHours = (tzMs - utcMs) / 3600000;
                        onSuccess(offsetHours.toString());
                    } catch(e) { onError(e.toString()); }
                })
                .catch(e => onError(e.toString()));
        },
        'com.aizsquare.secretsalah.platform.jsInstallOtpAutoFill' : (onOtp) => {
            const OLD = document.getElementById('__ss_otp');
            if (OLD) { if (OLD.__cleanup) OLD.__cleanup(); OLD.remove(); }
        
            const inp = document.createElement('input');
            inp.id            = '__ss_otp';
            inp.type          = 'text';
            inp.autocomplete  = 'one-time-code';
            inp.inputMode     = 'numeric';
            inp.pattern       = '[0-9]*';
            inp.autocorrect   = 'off';
            inp.autocapitalize = 'none';
            inp.spellcheck    = false;
            // Bottom-left corner: least likely to interfere with Compose canvas hit-testing
            inp.style.cssText = [
                'position:fixed', 'z-index:9999',
                'bottom:0', 'left:0',
                'width:1px', 'height:1px',
                'opacity:0.01',
                'border:none', 'outline:none', 'padding:0',
                'font-size:16px',
                'background:transparent', 'color:transparent', 'caret-color:transparent'
            ].join(';');
            document.body.appendChild(inp);
        
            function onInput() {
                const val = inp.value.replace(/\D/g, '').slice(0, 6);
                if (val.length === 6) {
                    // Only forward on a complete 6-digit auto-fill.
                    // Partial values are intentionally ignored — the Compose OTP field
                    // handles manual keystroke-by-keystroke input on its own.
                    onOtp(val);
                    // Clear so a second auto-fill can fire later in the same session.
                    setTimeout(function() { inp.value = ''; }, 400);
                }
            }
            inp.addEventListener('input', onInput);
        
            // Single programmatic focus attempt.
            // If iOS honours it: numeric keyboard + OTP QuickType suggestion appear.
            // If iOS ignores it: harmless — user types in Compose field normally.
            try { inp.focus(); } catch (e) {}
        
            inp.__cleanup = function() {
                inp.removeEventListener('input', onInput);
            };
        },
        'com.aizsquare.secretsalah.platform.jsRemoveOtpAutoFill' : () => {
            const el = document.getElementById('__ss_otp');
            if (el) { if (el.__cleanup) el.__cleanup(); el.remove(); }
        },
        'com.aizsquare.secretsalah.platform.jsGetCountryCode' : () => {
            try {
                // Timezone is far more reliable than locale for physical location
                const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const tzMap = {
                    // A
                    'Asia/Kabul': 'af',
                    'Europe/Tirane': 'al',
                    'Africa/Algiers': 'dz',
                    'America/Argentina/Buenos_Aires': 'ar', 'America/Buenos_Aires': 'ar',
                    'America/Argentina/Cordoba': 'ar', 'America/Argentina/Mendoza': 'ar',
                    'Australia/Sydney': 'au', 'Australia/Melbourne': 'au',
                    'Australia/Brisbane': 'au', 'Australia/Perth': 'au',
                    'Australia/Adelaide': 'au', 'Australia/Darwin': 'au',
                    'Europe/Vienna': 'at',
                    'Asia/Baku': 'az',
                    // B
                    'Asia/Bahrain': 'bh',
                    'Asia/Dhaka': 'bd',
                    'Europe/Brussels': 'be',
                    'Europe/Sarajevo': 'ba',
                    'America/Sao_Paulo': 'br', 'America/Manaus': 'br',
                    'America/Fortaleza': 'br', 'America/Belem': 'br',
                    // C
                    'America/Toronto': 'ca', 'America/Vancouver': 'ca',
                    'America/Winnipeg': 'ca', 'America/Halifax': 'ca',
                    'America/St_Johns': 'ca', 'America/Regina': 'ca',
                    'Asia/Shanghai': 'cn', 'Asia/Urumqi': 'cn',
                    // D
                    'Europe/Copenhagen': 'dk',
                    // E
                    'Africa/Cairo': 'eg',
                    'Africa/Addis_Ababa': 'et',
                    // F
                    'Europe/Helsinki': 'fi',
                    'Europe/Paris': 'fr',
                    // G
                    'Europe/Berlin': 'de',
                    'Africa/Accra': 'gh',
                    'Europe/Athens': 'gr',
                    // H
                    'Europe/Budapest': 'hu',
                    // I
                    'Asia/Kolkata': 'in', 'Asia/Calcutta': 'in',
                    'Asia/Jakarta': 'id', 'Asia/Makassar': 'id', 'Asia/Jayapura': 'id',
                    'Asia/Tehran': 'ir',
                    'Asia/Baghdad': 'iq',
                    'Europe/Dublin': 'ie',
                    'Asia/Jerusalem': 'il',
                    'Europe/Rome': 'it',
                    // J
                    'Asia/Tokyo': 'jp',
                    'Asia/Amman': 'jo',
                    // K
                    'Asia/Almaty': 'kz', 'Asia/Qyzylorda': 'kz', 'Asia/Aqtau': 'kz',
                    'Africa/Nairobi': 'ke',
                    'Asia/Kuwait': 'kw',
                    'Asia/Bishkek': 'kg',
                    // L
                    'Asia/Beirut': 'lb',
                    'Africa/Tripoli': 'ly',
                    // M
                    'Asia/Kuala_Lumpur': 'my', 'Asia/Kuching': 'my',
                    'Indian/Maldives': 'mv',
                    'Africa/Bamako': 'ml',
                    'Africa/Nouakchott': 'mr',
                    'America/Mexico_City': 'mx', 'America/Monterrey': 'mx',
                    'America/Merida': 'mx', 'America/Tijuana': 'mx',
                    'Africa/Casablanca': 'ma',
                    // N
                    'Europe/Amsterdam': 'nl',
                    'Pacific/Auckland': 'nz',
                    'Africa/Niamey': 'ne',
                    'Africa/Lagos': 'ng',
                    'Europe/Oslo': 'no',
                    // O
                    'Asia/Muscat': 'om',
                    // P
                    'Asia/Karachi': 'pk',
                    'Asia/Gaza': 'ps', 'Asia/Hebron': 'ps',
                    'Asia/Manila': 'ph',
                    'Europe/Warsaw': 'pl',
                    'Europe/Lisbon': 'pt', 'Atlantic/Azores': 'pt',
                    // Q
                    'Asia/Qatar': 'qa',
                    // R
                    'Europe/Bucharest': 'ro',
                    'Europe/Moscow': 'ru', 'Asia/Yekaterinburg': 'ru',
                    'Asia/Omsk': 'ru', 'Asia/Novosibirsk': 'ru',
                    'Asia/Krasnoyarsk': 'ru', 'Asia/Irkutsk': 'ru',
                    'Asia/Yakutsk': 'ru', 'Asia/Vladivostok': 'ru',
                    // S
                    'Asia/Riyadh': 'sa',
                    'Africa/Dakar': 'sn',
                    'Asia/Singapore': 'sg',
                    'Africa/Mogadishu': 'so',
                    'Africa/Johannesburg': 'za',
                    'Asia/Seoul': 'kr',
                    'Europe/Madrid': 'es', 'Atlantic/Canary': 'es',
                    'Asia/Colombo': 'lk',
                    'Africa/Khartoum': 'sd',
                    'Europe/Stockholm': 'se',
                    'Europe/Zurich': 'ch',
                    'Asia/Damascus': 'sy',
                    // T
                    'Asia/Dushanbe': 'tj',
                    'Africa/Dar_es_Salaam': 'tz',
                    'Asia/Bangkok': 'th',
                    'Africa/Tunis': 'tn',
                    'Europe/Istanbul': 'tr',
                    'Asia/Ashgabat': 'tm',
                    // U
                    'Africa/Kampala': 'ug',
                    'Europe/Kiev': 'ua', 'Europe/Kyiv': 'ua',
                    'Asia/Dubai': 'ae',
                    'Europe/London': 'gb',
                    'America/New_York': 'us', 'America/Chicago': 'us',
                    'America/Denver': 'us', 'America/Los_Angeles': 'us',
                    'America/Phoenix': 'us', 'America/Anchorage': 'us',
                    'Pacific/Honolulu': 'us',
                    'Asia/Tashkent': 'uz', 'Asia/Samarkand': 'uz',
                    // Y
                    'Asia/Aden': 'ye',
                };
                const cc = tzMap[tz];
                if (cc) return cc;
                // Fallback: parse region from locale (e.g. "en-IN" → "in")
                const locale = Intl.DateTimeFormat().resolvedOptions().locale;
                const parts = locale.split('-');
                return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
            } catch (e) {
                return '';
            }
        },
        'com.aizsquare.secretsalah.platform.jsFetchIpCountryCode' : (onSuccess, onError) => {
            fetch('https://ipapi.co/country_code/')
                .then(r => r.text())
                .then(t => onSuccess(t.trim().toLowerCase()))
                .catch(() => onError(''));
        }
    }
    
    // Placed here to give access to it from externals (js_code)
    let wasmInstance;
    let require; 
    let wasmExports;

    const isNodeJs = (typeof process !== 'undefined') && (process.release.name === 'node');
    const isDeno = !isNodeJs && (typeof Deno !== 'undefined')
    const isStandaloneJsVM =
        !isDeno && !isNodeJs && (
            typeof d8 !== 'undefined' // V8
            || typeof inIon !== 'undefined' // SpiderMonkey
            || typeof jscOptions !== 'undefined' // JavaScriptCore
        );
    const isBrowser = !isNodeJs && !isDeno && !isStandaloneJsVM && (typeof window !== 'undefined' || typeof self !== 'undefined');
    
    if (!isNodeJs && !isDeno && !isStandaloneJsVM && !isBrowser) {
      throw "Supported JS engine not detected";
    }
    
    const wasmFilePath = './composeApp.wasm';
    const importObject = {
        js_code,
        intrinsics: {
            
        },
        './skiko.mjs': imports['./skiko.mjs'],

    };
    
    try {
      if (isNodeJs) {
        const module = await import(/* webpackIgnore: true */'node:module');
        const importMeta = import.meta;
        require = module.default.createRequire(importMeta.url);
        const fs = require('fs');
        const url = require('url');
        const filepath = import.meta.resolve(wasmFilePath);
        const wasmBuffer = fs.readFileSync(url.fileURLToPath(filepath));
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isDeno) {
        const path = await import(/* webpackIgnore: true */'https://deno.land/std/path/mod.ts');
        const binary = Deno.readFileSync(path.fromFileUrl(import.meta.resolve(wasmFilePath)));
        const module = await WebAssembly.compile(binary);
        wasmInstance = await WebAssembly.instantiate(module, importObject);
      }
      
      if (isStandaloneJsVM) {
        const wasmBuffer = read(wasmFilePath, 'binary');
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isBrowser) {
        wasmInstance = (await WebAssembly.instantiateStreaming(fetch(new URL('./composeApp.wasm',import.meta.url).href), importObject)).instance;
      }
    } catch (e) {
      if (e instanceof WebAssembly.CompileError) {
        let text = `Please make sure that your runtime environment supports the latest version of Wasm GC and Exception-Handling proposals.
For more information, see https://kotl.in/wasm-help
`;
        if (isBrowser) {
          console.error(text);
        } else {
          const t = "\n" + text;
          if (typeof console !== "undefined" && console.log !== void 0) 
            console.log(t);
          else 
            print(t);
        }
      }
      throw e;
    }
    
    wasmExports = wasmInstance.exports;
    if (runInitializer) {
        wasmExports._initialize();
    }

    return { instance: wasmInstance,  exports: wasmExports };
}
